import { useEffect, useState } from 'react';

/**
 * Tracks whether the element matching `selector` is currently on screen.
 * Unlike useReveal this keeps watching, so it flips back to false when the
 * element scrolls away again. Returns false where IntersectionObserver is
 * unavailable, so callers fall back to their unconditional behaviour.
 */
export default function useInView(selector) {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;

    const el = document.querySelector(selector);
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting));
    observer.observe(el);
    return () => observer.disconnect();
  }, [selector]);

  return inView;
}
